import { Dispatch } from "redux";
import * as invDocActions from "../features/merchant/doc";
import * as invBizActions from "../features/institutionalInvestor/bizSlice";
import * as invRepActions from "../features/institutionalInvestor/repSlice";
import * as invBankActions from "../features/institutionalInvestor/bankSlice";

export const initializeDocuments = (dispatch: Dispatch, data: any) => {
  dispatch(
    invDocActions.setBusinessDoc({ business: data.businessProfile || [] })
  );
  dispatch(invDocActions.setProofDoc({ proof: data.proofOfAddress || [] }));
  dispatch(
    invDocActions.setShareDoc({
      share: data.shareHoldersDirectorsRegisters || [],
    })
  );
  dispatch(
    invDocActions.setFinancialStatementDoc({
      financialStatement: data.financialStatement || [],
    })
  );
  dispatch(
    invDocActions.setInvestmentMandateDoc({
      investmentMandate: data.investmentMandate || [],
    })
  );
  dispatch(
    invDocActions.setFundManagerLicenseDoc({
      fundManagerLicense: data.fundManagerLicense || [],
    })
  );
};

export const initializeBusinessDetails = (
  dispatch: Dispatch,
  data: any,
  industryDropdownValues?: any
) => {
  dispatch(invBizActions.setCompanyRedux({ company: data.companyName }));
  dispatch(
    invBizActions.setRegNumberRedux({ regNumber: data.companyRegistrationNo })
  );
  dispatch(
    invBizActions.setLegalStructureRedux({
      legalStructure: data.legalStructure,
    })
  );
  dispatch(
    invBizActions.setLegalStructureOthersRedux({
      legalStructureOthers: data.legalStructureOthers,
    })
  );
  dispatch(
    invBizActions.setCountryOfIncorpRedux({
      countryOfIncorp: data.countryOfIncorporation,
    })
  );
  dispatch(
    invBizActions.setCountryOfDomicileRedux({
      countryOfDomicile: data.countryOfDomicile,
    })
  );
  dispatch(invBizActions.setAddressRedux({ address: data.legalEntityAddress }));
  dispatch(
    invBizActions.setPostalCodeRedux({ postal: data.postalCode?.toString() })
  );
  dispatch(invBizActions.setWebsiteRedux({ website: data.website }));
  dispatch(
    invBizActions.setPhoneNumberRedux({ phoneNumber: data.phoneNumber })
  );
  dispatch(
    invBizActions.setIndustryGroupRedux({ industryGroup: data.industryGroup })
  );
  dispatch(invBizActions.setIndustryRedux({ industry: data.industry }));
  dispatch(
    invBizActions.setIndustryDropdownValuesRedux({
      industryDropdownValues: industryDropdownValues,
    })
  );
  dispatch(
    invBizActions.setInvestmentAmountRedux({
      investmentAmount: data.investmentAmount || 0,
    })
  );
  dispatch(
    invBizActions.setIncorporationDateRedux({
      incorporationDate: data.companyStartDate,
    })
  );
};

export const initializeRepresentativeDetails = (
  dispatch: Dispatch,
  data: any
) => {
  dispatch(
    invRepActions.setRepFirstNameRedux({ repFirstName: data.repFirstName })
  );
  dispatch(
    invRepActions.setRepLastNameRedux({ repLastName: data.repLastName })
  );
  dispatch(invRepActions.setRepEmailRedux({ repEmail: data.repEmail }));
  dispatch(invRepActions.setRepTitleRedux({ repTitle: data.repTitle }));
  dispatch(invRepActions.setUserTitleRedux({ userTitle: data.userTitle }));
  dispatch(
    invRepActions.setShareholderDirectorRedux({
      shareholdersDirectors: data.shareHoldersDirectors || [],
    })
  );
};

export const initializeBankDetails = (dispatch: Dispatch, data: any) => {
  dispatch(invBankActions.setBankNameRedux({ bankName: data.bankName }));
  dispatch(
    invBankActions.setAccountTypeRedux({ accountType: data.accountType })
  );
  dispatch(
    invBankActions.setAccountNoRedux({ accountNumber: data.accountNumber })
  );
  dispatch(
    invBankActions.setAccountHolderNameRedux({
      accountHolderName: data.accountHolderName,
    })
  );
  dispatch(invBankActions.setSwiftCodeReduct({ swiftCode: data.swiftCode }));
};
